module.exports = __webpack_public_path__ + "static/media/portfoli_banner3_left_img.b23f5a82.png";